import React, { Component } from 'react';
import { css } from 'astroturf';
import ReactTooltip from 'react-tooltip';
import { StaticImage } from 'gatsby-plugin-image';
import { ArrowRight } from 'react-bytesize-icons';

import Logo from '../../../assets/images/icon.svg';
import Link from '../../components/link';

const styles = css`
  .card {
    padding: 1.5rem;
    border-radius: 5px;
    background-color: #fff;
    box-shadow:
      rgba(0, 0, 0, 0.024) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.05) 0px 1px 0px,
      rgba(0, 0, 0, 0.03) 0px 0px 8px,
      rgba(0, 0, 0, 0.1) 0px 20px 30px;
    margin-bottom: 3rem;
    overflow: hidden;

    &.attention {
      position: relative;
      overflow: hidden;
      padding: 3rem 1.5rem;
      background: rgb(115, 177, 221) linear-gradient(135deg, rgb(115, 177, 221), rgb(115, 221, 177));
      display: flex;
      gap: 1rem;

      > div {
        position: relative;
        flex: 1 1 50%;
      }

      h3 {
        margin-bottom: 0.5rem;
      }
      p {
        line-height: 1.5;
        color: #000;
        text-wrap: balance;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .app {
        position: absolute;
        left: 0;
        flex: 0 0 551px;
        border-radius: 5px;
        box-shadow:
          rgba(0, 0, 0, 0.024) 0px 0px 0px 1px,
          rgba(0, 0, 0, 0.05) 0px 1px 0px,
          rgba(0, 0, 0, 0.03) 0px 0px 8px,
          rgba(0, 0, 0, 0.1) 0px 20px 30px;

        width: 551px;
        height: 242px;
      }
    }

    &.buttonscard {
      margin-bottom: 10rem;
    }

    a {
      color: #000;
    }

    textarea {
      display: block;
      width: 100%;
      height: 200px;
      padding: 1rem;
      border: 1px solid #ddd;
      border-radius: 5px;
      font-family: monospace;
      font-size: 14px;
      resize: vertical;
    }

    button.analyze {
      width: 100%;
      padding: 0.75rem 1rem;
      background-color: #000;
      color: #fff;
      border: none;
      border-radius: 0.25rem;
      cursor: pointer;
      font-size: 16px;
      margin-top: 1rem;
      background-color: rgb(10, 21, 48);
      &:hover,
      &:focus {
        background-color: rgb(20, 31, 64);
      }
    }

    .suggestions {
      margin: 0.5rem 0 0;
    }

    button.adddefault {
      font: inherit;
      line-height: 1;
      border: none;
      background: none;
      text-decoration: none;
      color: rgb(0, 124, 165);
      border-bottom: 1px solid rgb(0, 124, 165);
      cursor: pointer;

      &:hover,
      &:focus {
        color: #000;
      }
    }

    .error {
      margin-top: 1rem;
      background-color: rgb(254, 242, 242);
      color: rgb(220, 38, 38);
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    h3 {
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      svg {
        flex-shrink: 0;
        width: 24px;
        stroke: #39728d;
      }
    }
    p {
      margin: 0.25rem 0 1rem;
      color: #666;
    }

    .overflowauto {
      width: 100%;
      overflow-x: auto;
    }

    table {
      margin-top: 1rem;
      width: 100%;

      tr:not(:has(+ .detailsrow)) :is(th, td) {
        border-bottom: 1px solid #ddd;

        padding: 0.5rem 0.5rem;
      }

      th {
        color: #39728d;
        text-align: left;
        font-size: 0.9em;
        padding: 0 0.5rem 0.5rem;

        &:last-child {
          text-align: right;
        }
      }

      td {
        padding: 0.5rem 0.5rem 0;
        vertical-align: top;

        &:last-child {
          text-align: right;
        }

        & em {
          opacity: 0.5;
        }
      }

      .elementname {
        font-family: monospace;
        color: #39728d;
      }

      .requiredblock {
        svg {
          padding: 0.25rem;
          stroke-width: 4px;
          background: #fff;
          color: rgb(48, 166, 134);
          border: 2px solid rgb(48, 166, 134);
          border-radius: 50%;
        }

        span.optional {
          opacity: 0.5;
        }
      }

      button {
        border: none;
        background: none;
        cursor: pointer;
        color: #39728d;
        padding: 0.25rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &:hover,
        &:focus-visible {
          color: #000;
        }
      }

      .detailsrow {
        td {
          padding-top: 0;
        }
        div {
          text-align: left;
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: auto;

          div {
            font-size: 12px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 1rem;

            span {
              color: #39728d;
            }
          }
        }
      }
    }
  }

  .numbers {
    display: flex;
    flex-wrap: wrap;
    p {
      margin: 0;
    }

    & > div {
      flex: 1 1 25%;
      min-width: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .number {
      margin: 0;
      font-size: 2rem;
      line-height: 1;
      font-weight: 700;
      color: inherit;
    }

    .total {
      color: #639cb8;
    }
    .required {
      color: green;
    }
    .fieldsets {
      color: orange;
    }
    .buttons {
      color: purple;
    }
  }

  .badge {
    font-size: 12px;
    display: inline-block;
    padding: 0.125rem 0.5rem;
    background: color-mix(in lab, #fff 80%, transparent);
    border-radius: 4rem;
    color: #000;
    border: 1px solid #9994;
    user-select: none;
    white-space: nowrap;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;

    span {
      color: #39728d;
    }

    svg {
      width: 1em;
      height: 1em;
      stroke: #39728d;
    }

    &[data-type='success'] {
      width: 100px;
      border-color: rgb(99, 184, 156);
      color: rgb(59, 110, 93);
      background: color-mix(in lab, rgb(99, 184, 156) 10%, transparent);
      svg {
        stroke: rgb(48, 166, 134);
      }
    }

    &[data-type='warn'] {
      border-color: rgb(234, 179, 8);
      color: rgb(110, 78, 0);
      background: color-mix(in lab, rgb(234, 179, 8) 10%, transparent);
      svg {
        stroke: rgb(234, 179, 8);
      }
    }
  }

  a.button {
    display: inline-block;
    position: relative;
    outline: none;
    align-self: center;
    z-index: 2;
    border: 0;
    height: 35px;
    line-height: 35px;
    border-radius: 10px;
    font-size: 1rem;
    color: #fff;
    font-weight: 700;
    white-space: nowrap;
    opacity: 1;
    padding: 0;
    background: linear-gradient(135deg, #2c82ad, #67b26f);
    margin: 0 0 0;

    & i {
      display: block;
      height: 35px;
      line-height: 35px;
      border-radius: 10px;
      padding: 0 1.5rem;
      transition: 0.25s ease-out background;
      background: #0a1530;
      font-style: normal;

      @media (forced-colors: active) {
        border: 1px solid;
      }

      & svg {
        vertical-align: middle;
        margin-left: 4px;
        margin-top: -1px;
        transition: 0.25s ease-in-out transform;
      }
    }

    &:hocus {
      & i {
        background: transparent;
      }

      & svg {
        transform: translateX(8px);
      }
    }
  }
`;

const collator = new Intl.Collator('en', { sensitivity: 'base' });

class Inspector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      htmlInput: '',
      formInfo: false,
      error: null,
      expandedFields: new Set(),
      expandedButtons: new Set(),
    };
  }

  componentDidUpdate(prevProps, prevState) {
    ReactTooltip.rebuild();
  }

  setError = (error) => {
    this.setState({ error });
  };

  setFormInfo = (formInfo) => {
    this.setState({ formInfo });
  };

  setExpandedFields = (expandedFields) => {
    this.setState({ expandedFields });
  };

  setExpandedButtons = (expandedButtons) => {
    this.setState({ expandedButtons });
  };

  parseForm = () => {
    try {
      this.setError(null);
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.state.htmlInput, 'text/html');
      const form = doc.querySelector('form');

      if (!form) {
        this.setError('No form element found in the HTML');
        return;
      }

      const action = form.getAttribute('action');
      const method = form.getAttribute('method') || 'get';

      const fields = [];
      const buttons = [];

      // Find all fieldsets first to preserve order
      const fieldsets = Array.from(form.querySelectorAll('fieldset'));
      const fieldsetOrderMap = new Map();
      fieldsets.forEach((fieldset, index) => {
        fieldsetOrderMap.set(fieldset, index);
      });

      // Find all input, select, textarea, button elements
      const inputs = form.querySelectorAll('input, select, textarea, button');

      inputs.forEach((input) => {
        const element = input;
        const type = element.type || element.tagName.toLowerCase();
        const name = element.name || '';
        const id = element.id || '';
        const required = element.hasAttribute('required');
        const disabled = element.hasAttribute('disabled');
        const value = element.getAttribute('value') || '';
        const attributes = Array.from(element.attributes)
          .reduce((acc, attr) => {
            // Skip common attributes that are not useful for analysis
            if (['name', 'type', 'value', 'required', 'disabled', 'checked'].includes(attr.name)) {
              return acc;
            }

            acc.push({
              name: attr.name,
              value: attr.value,
            });

            return acc;
          }, [])
          .sort((a, b) => collator.compare(a.name.toLowerCase(), b.name.toLowerCase()));

        // Handle buttons (submit, reset, button)
        if (type === 'submit' || type === 'reset' || type === 'button' || element.tagName.toLowerCase() === 'button') {
          buttons.push({
            id,
            name,
            type,
            value: value || element.textContent?.trim() || '',
            disabled,
            attributes,
            nodeName: element.nodeName.toLowerCase(), // Add this line
          });
          return;
        }

        // Skip hidden inputs for the main analysis
        if (type === 'hidden') {
          return;
        }

        // Handle checkbox grouping - REMOVE THIS ENTIRE SECTION
        // Replace with simple individual field processing for all input types

        // Get checked status for checkboxes and radio buttons
        let checked;
        if (type === 'checkbox' || type === 'radio') {
          checked = element.hasAttribute('checked');
        }

        // Find associated label - improved logic
        let label = '';
        const labelElement = form.querySelector(`label[for="${id}"]`);
        if (labelElement) {
          label = labelElement.textContent?.replace(/\*/g, '').trim() || '';
        } else {
          // Check if the input is inside a label
          const parentLabel = element.closest('label');
          if (parentLabel) {
            // Get the text content but exclude nested input elements
            const clone = parentLabel.cloneNode(true);
            const inputs = clone.querySelectorAll('input, select, textarea, button');
            inputs.forEach((input) => input.remove());
            label = clone.textContent?.replace(/\*/g, '').trim() || '';
          }
        }

        // Check if it's part of a fieldset
        const fieldset = element.closest('fieldset');
        let fieldsetLegend = '';
        if (fieldset) {
          const legend = fieldset.querySelector('legend');
          if (legend) {
            fieldsetLegend = legend.textContent?.replace(/\*/g, '').trim() || '';
          } else {
            // If no legend, show "(without legend)" instead of generic fieldset name
            fieldsetLegend = '(without legend)';
          }
        }

        const field = {
          id,
          attributes,
          name,
          type,
          label,
          required,
          disabled,
          value: value || undefined,
          checked,
          fieldset: fieldsetLegend || undefined,
          nodeName: element.nodeName.toLowerCase(), // Add this line
        };

        fields.push(field);
      });

      // Group fields and checkbox groups by fieldset, preserving order
      const fieldsetMap = new Map();
      const ungroupedFields = [];

      // Process regular fields
      fields.forEach((field) => {
        if (field.fieldset) {
          if (!fieldsetMap.has(field.fieldset)) {
            // Find the order of this fieldset
            const fieldsetElement = Array.from(form.querySelectorAll('fieldset')).find((fs) => {
              const legend = fs.querySelector('legend');
              const legendText = legend?.textContent?.replace(/\*/g, '').trim() || '';
              // Handle both legend text and "(without legend)" for fieldsets without legends
              return legendText === field.fieldset || (legendText === '' && field.fieldset === '(without legend)');
            });
            const order = fieldsetElement ? fieldsetOrderMap.get(fieldsetElement) || 0 : 0;

            fieldsetMap.set(field.fieldset, { fields: [], order });
          }
          fieldsetMap.get(field.fieldset).fields.push(field);
        } else {
          ungroupedFields.push(field);
        }
      });

      // Convert to array and sort by order
      const orderedFieldsets = [];
      fieldsetMap.forEach(({ fields, order }, legend) => {
        orderedFieldsets.push({ legend, fields, order });
      });
      orderedFieldsets.sort((a, b) => a.order - b.order);

      this.setFormInfo({
        action,
        method,
        fields: ungroupedFields,
        buttons,
        fieldsets: orderedFieldsets,
      });

      // Reset expanded states when new form is parsed
      this.setExpandedFields(new Set());
      this.setExpandedButtons(new Set());
    } catch (err) {
      this.setError('Error parsing HTML: ' + err.message);
    }
  };

  toggleFieldExpansion = (fieldId) => {
    const newExpanded = new Set(this.state.expandedFields);
    if (newExpanded.has(fieldId)) {
      newExpanded.delete(fieldId);
    } else {
      newExpanded.add(fieldId);
    }
    this.setExpandedFields(newExpanded);
  };

  toggleButtonExpansion = (buttonId) => {
    const newExpanded = new Set(this.state.expandedButtons);
    if (newExpanded.has(buttonId)) {
      newExpanded.delete(buttonId);
    } else {
      newExpanded.add(buttonId);
    }
    this.setExpandedButtons(newExpanded);
  };

  addContactForm = (e) => {
    e.preventDefault();
    this.setState(
      {
        htmlInput: contactFormHTML,
      },
      () => {
        this.parseForm();
      }
    );
  };

  addLoginForm = (e) => {
    e.preventDefault();
    this.setState(
      {
        htmlInput: loginFormHTML,
      },
      () => {
        this.parseForm();
      }
    );
  };

  addDefaultForm = (e) => {
    e.preventDefault();
    this.setState(
      {
        htmlInput: defaultFormHTML,
      },
      () => {
        this.parseForm();
      }
    );
  };

  render() {
    const { formInfo } = this.state;

    return (
      <div className="page widePage forminspector">
        <div className={styles.card}>
          <h3>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-file-smile"
            >
              <path d="M14 3v4a1 1 0 0 0 1 1h4" />
              <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2zm-7 -7h.01m3.99 0h.01" />
              <path d="M10 17a3.5 3.5 0 0 0 4 0" />
            </svg>
            HTML Form Input
          </h3>
          <p>Paste your HTML form code below and click "Analyze Form" to see the breakdown</p>
          <textarea
            onChange={(e) => this.setState({ htmlInput: e.target.value })}
            placeholder="Paste your HTML form code here..."
            value={this.state.htmlInput}
          />
          <button className={styles.analyze} onClick={this.parseForm} type="button">
            Analyze Form
          </button>
          <p className={styles.suggestions}>
            Try some:{' '}
            <button
              type="button"
              onClick={this.addContactForm}
              className={[styles.adddefault, this.state.htmlInput ? styles.disabled : ''].join(' ')}
            >
              contact form
            </button>
            ,{' '}
            <button
              type="button"
              onClick={this.addLoginForm}
              className={[styles.adddefault, this.state.htmlInput ? styles.disabled : ''].join(' ')}
            >
              login form
            </button>
            ,{' '}
            <button
              type="button"
              onClick={this.addDefaultForm}
              className={[styles.adddefault, this.state.htmlInput ? styles.disabled : ''].join(' ')}
            >
              multiple fieldsets
            </button>
          </p>
          {this.state.error && (
            <div className={styles.error}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-alert-square-rounded"
              >
                <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
                <path d="M12 8v4" />
                <path d="M12 16h.01" />
              </svg>
              <span>{this.state.error}</span>
            </div>
          )}
        </div>

        {formInfo && (
          <>
            <div className={styles.card}>
              <div className={styles.numbers}>
                {formInfo.fields.length + formInfo.fieldsets.reduce((acc, fs) => acc + fs.fields.length, 0) > 0 && (
                  <div className={styles.total}>
                    <p className={styles.number}>
                      {formInfo.fields.length + formInfo.fieldsets.reduce((acc, fs) => acc + fs.fields.length, 0)}
                    </p>
                    <p className={styles.numberText}>
                      Total Field
                      {formInfo.fields.length + formInfo.fieldsets.reduce((acc, fs) => acc + fs.fields.length, 0) === 1
                        ? ''
                        : 's'}
                    </p>
                  </div>
                )}
                {[
                  ...formInfo.fields.filter((f) => f.required),
                  ...formInfo.fieldsets.flatMap((fs) => fs.fields.filter((f) => f.required)),
                ].length > 0 && (
                  <div className={styles.required}>
                    <p className={styles.number}>
                      {
                        [
                          ...formInfo.fields.filter((f) => f.required),
                          ...formInfo.fieldsets.flatMap((fs) => fs.fields.filter((f) => f.required)),
                        ].length
                      }
                    </p>
                    <p className={styles.numberText}>
                      Required Field
                      {[
                        ...formInfo.fields.filter((f) => f.required),
                        ...formInfo.fieldsets.flatMap((fs) => fs.fields.filter((f) => f.required)),
                      ].length === 1
                        ? ''
                        : 's'}
                    </p>
                  </div>
                )}
                {formInfo.fieldsets.length > 0 && (
                  <div className={styles.fieldsets}>
                    <p className={styles.number}>{formInfo.fieldsets.length}</p>
                    <p className={styles.numberText}>Fieldset{formInfo.fieldsets.length === 1 ? '' : 's'}</p>
                  </div>
                )}
                {formInfo.buttons.length > 0 && (
                  <div className={styles.buttons}>
                    <p className={styles.number}>{formInfo.buttons.length}</p>
                    <p className={styles.numberText}>Button{formInfo.buttons.length === 1 ? '' : 's'}</p>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.card}>
              <h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-settings"
                >
                  <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                  <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                </svg>
                Form Configuration
              </h3>
              <table>
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Method</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {formInfo.action === '' ? <em>Current page</em> : formInfo.action || <em>Not specified</em>}
                    </td>
                    <td>
                      <Badge>{formInfo.method.toUpperCase()}</Badge>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className={styles.card}>
              <h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-forms"
                >
                  <path d="M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3" />
                  <path d="M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3" />
                  <path d="M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7" />
                  <path d="M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1" />
                  <path d="M17 12h.01" />
                  <path d="M13 12h.01" />
                </svg>
                Form Fields
              </h3>
              <p>Individual form fields not in fieldsets</p>

              {formInfo.fields.length > 0 && (
                <div className={styles.overflowauto}>
                  <table>
                    {(() => {
                      const hasDisabledFields = formInfo.fields.some((f) => f.disabled);
                      const hasRequiredFields = formInfo.fields.some((f) => f.required);
                      return (
                        <>
                          <thead>
                            <tr>
                              <th>Element</th>
                              <th>Type</th>
                              <th>Label</th>
                              <th>Value/Status</th>
                              {hasRequiredFields && <th>Required</th>}
                              {hasDisabledFields && <th>Disabled</th>}
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formInfo.fields.map((field, index) => (
                              <FieldDetailsRow
                                key={index}
                                field={field}
                                index={index}
                                showDisabledColumn={hasDisabledFields}
                                showRequiredColumn={hasRequiredFields}
                                expandedFields={this.state.expandedFields}
                                toggleFieldExpansion={this.toggleFieldExpansion}
                              />
                            ))}
                          </tbody>
                        </>
                      );
                    })()}
                  </table>
                </div>
              )}
            </div>

            <div className={[styles.card, styles.attention].join(' ')}>
              <div>
                <Logo />
                <h3>Want suggestions on how to improve this form?</h3>
                <p>
                  Polypane can detect misconfigured form fields, missing labels and more. All in real-time with
                  Polypane's <Link to="/docs/outline-panel/#forms">Form outline</Link>.{' '}
                </p>
                <div className={styles.overflowauto}>
                  <p className={styles.cta}>
                    <Link className={[styles.button].join(' ')} to="https://dashboard.polypane.app/register/">
                      <i>
                        Start Free Trial <ArrowRight width={16} height={16} strokeWidth="4px" id="" />
                      </i>
                    </Link>
                  </p>
                </div>
              </div>

              <div>
                <StaticImage
                  src="../../../assets/images/formcta.png"
                  className={styles.app}
                  alt=""
                  width="551"
                  breakpoints={[150, 551]}
                  loading="lazy"
                  placeholder="none"
                  backgroundColor="#353447"
                  quality="100"
                />
              </div>
            </div>

            {formInfo.fieldsets.map((fieldset, index) => (
              <div key={index}>
                {/* Desktop Table */}
                <div className={styles.card}>
                  <h3>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-stack-2"
                    >
                      <path d="M12 4l-8 4l8 4l8 -4l-8 -4" />
                      <path d="M4 12l8 4l8 -4" />
                      <path d="M4 16l8 4l8 -4" />
                    </svg>
                    Fieldset: {fieldset.legend || <em>(without legend)</em>}
                  </h3>
                  <p>Grouped form fields under this fieldset</p>

                  {fieldset.fields.length > 0 && (
                    <div className={styles.overflowauto}>
                      <table>
                        {/* For each fieldset */}
                        {(() => {
                          const fieldsetHasDisabledFields = fieldset.fields.some((f) => f.disabled);
                          const fieldsetHasRequiredFields = fieldset.fields.some((f) => f.required);
                          return (
                            <>
                              <thead>
                                <tr>
                                  <th>Element</th>
                                  <th>Type</th>
                                  <th>Label</th>
                                  <th>Value/Status</th>
                                  {fieldsetHasRequiredFields && <th>Required</th>}
                                  {fieldsetHasDisabledFields && <th>Disabled</th>}
                                  <th>Details</th>
                                </tr>
                              </thead>
                              <tbody>
                                {fieldset.fields.map((field, fieldIndex) => (
                                  <FieldDetailsRow
                                    key={`fieldset-${index}-field-${fieldIndex}`}
                                    field={field}
                                    index={`fieldset-${index}-field-${fieldIndex}`}
                                    showDisabledColumn={fieldsetHasDisabledFields}
                                    showRequiredColumn={fieldsetHasRequiredFields}
                                    expandedFields={this.state.expandedFields}
                                    toggleFieldExpansion={this.toggleFieldExpansion}
                                  />
                                ))}
                              </tbody>
                            </>
                          );
                        })()}
                      </table>
                    </div>
                  )}
                </div>
              </div>
            ))}

            {formInfo.buttons.length > 0 && (
              <>
                <div className={[styles.card, styles.buttonscard].join(' ')}>
                  <h3>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-hand-finger"
                    >
                      <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5" />
                      <path d="M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5" />
                      <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5" />
                      <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />
                    </svg>{' '}
                    Form Buttons
                  </h3>
                  <p>Submit, reset, and other interactive buttons in the form</p>
                  <div className={styles.overflowauto}>
                    <table>
                      {(() => {
                        const hasDisabledButtons = formInfo.buttons.some((b) => b.disabled);
                        return (
                          <>
                            <thead>
                              <tr>
                                <th>Element</th>
                                <th>Type</th>
                                <th>Label</th>
                                {hasDisabledButtons && <th>Disabled</th>}
                                <th>Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formInfo.buttons.map((button, index) => (
                                <ButtonDetailsRow
                                  key={index}
                                  button={button}
                                  index={index}
                                  showDisabledColumn={hasDisabledButtons}
                                  expandedButtons={this.state.expandedButtons}
                                  toggleButtonExpansion={this.toggleButtonExpansion}
                                />
                              ))}
                            </tbody>
                          </>
                        );
                      })()}
                    </table>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    );
  }
}

export default Inspector;

const FieldDetailsRow = ({
  field,
  index,
  showDisabledColumn,
  showRequiredColumn,
  expandedFields,
  toggleFieldExpansion,
}) => {
  const fieldKey = `field-${index}-${field.name || field.id}`;
  const isOpen = expandedFields.has(fieldKey);

  return (
    <>
      <tr className={styles.mainrow}>
        <td className={styles.elementname}>&lt;{field.nodeName}&gt;</td>
        <td>
          <Badge>
            {field.type}
            {field.name && <span>{field.name}</span>}
          </Badge>
        </td>
        <td>{field.label || <em>no label</em>}</td>
        <td>
          <div>
            {field.value ? field.value : field.checked !== undefined ? '' : '-'}
            {field.checked !== undefined && (
              <Badge type={field.checked ? 'success' : ''}>
                {field.checked ? <Check /> : <X />}
                {field.checked ? 'Checked' : 'Unchecked'}
              </Badge>
            )}
          </div>
        </td>
        {showRequiredColumn && (
          <td className={styles.requiredblock}>
            {field.required ? (
              <span data-tip="Required">
                <Check />
              </span>
            ) : (
              <span className={styles.optional}>Optional</span>
            )}
          </td>
        )}
        {showDisabledColumn && (
          <td>
            {field.disabled ? (
              <Badge type="warn">
                <X /> Disabled
              </Badge>
            ) : null}
          </td>
        )}
        <td>
          <button type="button" onClick={() => toggleFieldExpansion(fieldKey)}>
            {isOpen ? <ChevronDown /> : <ChevronRight />}
          </button>
        </td>
      </tr>
      {isOpen && (
        <tr className={styles.detailsrow}>
          <td colSpan={4 + (showRequiredColumn ? 1 : 0) + (showDisabledColumn ? 1 : 0) + 1}>
            <div>
              {field.attributes.map((attr) => (
                <div key={attr.name}>
                  <span>{attr.name}:</span>
                  <code>{attr.value}</code>
                </div>
              ))}
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

const ButtonDetailsRow = ({ button, index, showDisabledColumn, expandedButtons, toggleButtonExpansion }) => {
  const buttonKey = `button-${index}-${button.name || button.id}`;
  const isOpen = expandedButtons.has(buttonKey);

  return (
    <>
      <tr className={styles.mainrow}>
        <td className={styles.elementname}>&lt;{button.nodeName}&gt;</td>
        <td>
          <Badge>
            {button.type}
            {button.name && <span>{button.name}</span>}
          </Badge>
        </td>
        <td>{button.value || 'No label'}</td>
        {showDisabledColumn && (
          <td>
            {button.disabled ? (
              <Badge variant="secondary" className="text-xs">
                Disabled
              </Badge>
            ) : (
              <span>Enabled</span>
            )}
          </td>
        )}
        <td>
          <button
            aria-expanded={isOpen}
            type="button"
            aria-label={isOpen ? 'Collapse details' : 'Expand details'}
            onClick={() => toggleButtonExpansion(buttonKey)}
          >
            {isOpen ? <ChevronDown /> : <ChevronRight />}
          </button>
        </td>
      </tr>
      {isOpen && (
        <tr className={styles.detailsrow}>
          <td colSpan={showDisabledColumn ? 5 : 4}>
            <div>
              {button.attributes.map((attr) => (
                <div key={attr.name}>
                  <span>{attr.name}:</span>
                  <code>{attr.value}</code>
                </div>
              ))}
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

const Badge = ({ type, children }) => (
  <span className={styles.badge} data-type={type}>
    {children}
  </span>
);

const contactFormHTML = `<form class="index-styles-module--contactForm--24f9w">
  <legend>How can we help?</legend>

  <label for="name">Name *</label>
  <input type="text" name="name" id="name" required="" value="">

  <label for="email">E-mail *</label>
  <input type="email" name="email" id="email" required="" value="">

  <label for="msg">Message/Question *</label>
  <textarea name="msg" id="msg" required=""></textarea>
  small>* required</small>

  <button type="submit">Ask question</button>
</form>`;

const loginFormHTML = `<form action="" method="post">
  <legend>Sign in to your account</legend>

  <label for="username">E-mail</label>
  <input type="text" id="username" name="username" required="" autocomplete="username" tabindex="1">

  <label for="password">Password</label>
  <a href="/forgot-password" tabindex="3">Forgot password?</a>
  <input type="password" id="password" name="password" required="" tabindex="2" autocomplete="current-password">

  <button tabindex="4">Sign in</button>
</form>`;

const defaultFormHTML = `<form action="/form-submission" method="post">
  <div class="required">
    <label for="name">Name <span class="star" aria-hidden="true">*</span></label>
    <input id="name" type="text" name="name" required="">
  </div>
  <div class="required">
    <label for="email">Email <span class="star" aria-hidden="true">*</span></label>
    <input id="email" type="email" name="email" required="">
  </div>
  <div>
    <label for="country">Country:</label>
    <input type="text" name="country" id="country">
  </div>
  <fieldset id="majors">
    <legend>Desired major(s):</legend>
    <ul>
      <li>
        <label for="cs">Computer Science</label>
        <input type="checkbox" name="major_cs" id="cs" checked>
      </li>
      <li>
        <label for="eng">Engineering</label>
        <input type="checkbox" name="major_eng" id="eng">
      </li>
      <li>
        <label for="eco">Economics</label>
        <input type="checkbox" name="major_econ" id="eco">
      </li>
      <li>
        <label for="phy">Physics</label>
        <input type="checkbox" name="major_phy" id="phy">
      </li>
      <li>
        <label for="psy">Psychology</label>
        <input type="checkbox" name="major_psy" id="psy">
      </li>
      <li>
        <label for="spa">Spanish</label>
        <input type="checkbox" name="major_sp" id="spa">
      </li>
    </ul>
  </fieldset>
  <div id="captcha"><fieldset><legend class="required">Security Question <span class="star" aria-hidden="true">*</span></legend><label id="captcha_label" for="captcha_answer">Cow, pizza, car. Which of these has more than three letters?</label><input id="captcha_answer" name="captcha_answer" type="text" required="required"></fieldset></div>
  <div>
    <input id="submit" type="submit" name="submit" value="Submit">
  </div>
</form>`;

const Check = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || 'currentColor'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-check"
  >
    <path d="M5 12l5 5l10 -10" />
  </svg>
);

const X = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-x"
  >
    <path d="M18 6l-12 12" />
    <path d="M6 6l12 12" />
  </svg>
);

const ChevronRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"
  >
    <path d="M9 6l6 6l-6 6" />
  </svg>
);

const ChevronDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"
  >
    <path d="M6 9l6 6l6 -6" />
  </svg>
);
